(function () {
  const mq = window.matchMedia("(min-width: 990px)");

  function getScrollParent(el) {
    let p = el;
    while (p && p !== document.body && p !== document.documentElement) {
      const s = getComputedStyle(p);
      const oy = s.overflowY;
      const canScroll = (oy === "auto" || oy === "scroll") && p.scrollHeight > p.clientHeight + 2;
      if (canScroll) return p;
      p = p.parentElement;
    }
    return null;
  }

  function getProductScope(fromEl) {
    return (
      fromEl.closest(".product, [data-section-type='main-product'], [data-section-id*='product']") ||
      document.querySelector(".product, [data-section-type='main-product'], [data-section-id*='product']") ||
      document
    );
  }

  // „Stop“-Marker: ab hier NICHT mehr hijacken (Beschreibung/Content darunter)
  function getStopMarker(scope) {
    return (
      scope.querySelector("#Beschreibung, #description, .product__description, [id*='description'], [class*='description']") ||
      scope.querySelector("h2, h3") || // fallback (Impact hat oft als nächstes die Description-Überschrift)
      null
    );
  }

  // Nur solange der Mauszeiger oberhalb der Beschreibung ist
  function isAboveStopMarker(scope, clientY) {
    const stop = getStopMarker(scope);
    if (!stop) return true; // wenn wir keinen Marker finden, lieber aktiv lassen
    const r = stop.getBoundingClientRect();
    return clientY < r.top; // Maus ist oberhalb der Beschreibung
  }

  document.addEventListener(
    "wheel",
    function (e) {
      if (!mq.matches) return;

      // Nur linke Hälfte des Viewports
      if (e.clientX >= window.innerWidth * 0.5) return;

      const scope = getProductScope(e.target);

      // Nur im oberen Bereich bis zur Beschreibung aktiv
      if (!isAboveStopMarker(scope, e.clientY)) return;

      // Element rechts auf gleicher Y-Position greifen
      const xRight = Math.min(window.innerWidth - 5, Math.floor(window.innerWidth * 0.75));
      const y = Math.min(window.innerHeight - 5, Math.max(5, e.clientY));
      const rightEl = document.elementFromPoint(xRight, y);
      if (!rightEl) return;

      const target = getScrollParent(rightEl);
      if (!target) return;

      // Nur innerhalb Produktbereich hijacken
      if (!scope.contains(target)) return;

      const delta = e.deltaY || 0;
      if (!delta) return;

      const atTop = target.scrollTop <= 0;
      const atBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 1;

      // Wenn am Rand: normale Seite scrollen lassen
      if ((delta < 0 && atTop) || (delta > 0 && atBottom)) return;

      e.preventDefault();
      target.scrollTop += delta;
    },
    { passive: false, capture: true }
  );
})();
